var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { transparentize } from 'polished';
import React, { useEffect, useState } from 'react';
import { layout, space } from 'styled-system';
import { css, keyframes, styled } from "../utils";
var Overlay = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 10;\n  background-color: rgba(255, 255, 255, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 10;\n  background-color: rgba(255, 255, 255, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var Container = styled.div(space, layout);
var BaseCircle = function (_a) {
    var props = __rest(_a, []);
    return React.createElement("circle", __assign({ cx: "70", cy: "70", r: "57", fill: "none" }, props));
};
var BgCircle = styled(BaseCircle)(function (_a) {
    var colors = _a.theme.colors;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    stroke: ", ";\n  "], ["\n    stroke: ", ";\n  "])), transparentize(0.6, colors.black));
});
var spin = keyframes(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  from, 0%, to {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"], ["\n  from, 0%, to {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"])));
var AnimatedCircle = styled(BaseCircle)(function (_a) {
    var color = _a.color, colors = _a.theme.colors;
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    stroke: ", ";\n    transform-origin: center center;\n    animation: ", " 0.5s linear infinite;\n  "], ["\n    stroke: ", ";\n    transform-origin: center center;\n    animation: ", " 0.5s linear infinite;\n  "])), color || colors.primary, spin);
});
var Dummy = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin: auto;\n  ", "\n"], ["\n  margin: auto;\n  ", "\n"])), space);
var Loader = function (_a) {
    var className = _a.className, color = _a.color, delay = _a.delay, tiny = _a.tiny, overlay = _a.overlay, props = __rest(_a, ["className", "color", "delay", "tiny", "overlay"]);
    var Wrapper = overlay ? Overlay : Dummy;
    var _b = useState(false), show = _b[0], setShow = _b[1];
    useEffect(function () {
        if (delay) {
            var timeout_1 = setTimeout(function () { return setShow(true); }, delay);
            return function () { return clearTimeout(timeout_1); };
        }
        else {
            setShow(true);
        }
    }, [delay]);
    return show ? (React.createElement(Wrapper, __assign({ className: className }, props),
        React.createElement(Container, __assign({ p: tiny ? 0 : 6, width: tiny ? '40px' : '100px', height: tiny ? '40px' : '100px', m: "0 auto" }, props),
            React.createElement("svg", { version: "1.1", x: "0px", y: "0px", width: "100%", height: "100%", viewBox: "0 0 140 140" },
                React.createElement(BgCircle, { id: "bg", strokeWidth: "7" }),
                React.createElement(AnimatedCircle, { strokeWidth: "8", color: color, strokeDasharray: "450", strokeDashoffset: "170", strokeLinecap: "round" }))))) : null;
};
Loader.defaultProps = {
    delay: 0,
    overlay: false,
    tiny: false,
};
export default Loader;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=Loader.js.map